module.exports = __webpack_public_path__ + "img/16.39652f0f.jpg";